<script>
  import parseData from "./data.js";
  import Table from "./components/Table.svelte";
  import Chart from "./components/Chart.svelte";

  const dataSrc = {
    countries: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vR6vTnS445ZAOr_plKVTVuDMGFpPBPBSur_c621cKMy19IKp6TDHWgwvYUH507vsFbT-QI9bDa4v94h/pub?gid=371374805&single=true&output=csv',
    ports: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vR6vTnS445ZAOr_plKVTVuDMGFpPBPBSur_c621cKMy19IKp6TDHWgwvYUH507vsFbT-QI9bDa4v94h/pub?gid=32437498&single=true&output=csv',
  };

  const data = loadData();

  async function loadData() {
    let res = await parseData({
      src: dataSrc,
    });
    return res;
  }

  $: selectedCountries = ['CHN', 'USA']

  const init = () => {
    resize(mq);
  };

  let isMobile = false;
  let mq = window.matchMedia("(max-width: 48em)");

  function resize(mediaQueryList) {
    if (mediaQueryList.matches) {
      isMobile = true;
    } else {
      isMobile = false;
    }
  }

  try {
    // Chrome & Firefox
    mq.addEventListener('change', (e) => {
      resize(e)
    })
  } catch (e1) {
    try {
      // Safari, because it doesn't support addEventListener...
      mq.addListener((e) => {
        resize(e)
      })
    } catch(e2) {
      console.error(e2)
    }
  }

  window.addEventListener("DOMContentLoaded", init);

</script>

<main class="interactive">
  <header class="interactive__header">
    <h1>The World's Most Connected Ports</h1>
    <p>
      This interactive visualizes the world's top 100 ports based on their connectivity to established global maritime shipping networks. Data is updated through Q1 2021 and comes from UNCTAD's Liner Shipping Connectivity Index (LSCI), which scores each country and their respective ports based on six different indicators. Use the drop-down menus to select which countries to compare. <span class="mobile-only">To explore all the features of this interactive, please view the page on a desktop computer.</span><span class="desktop-only">Hover over a bar to reveal information for a given port.</span>
    </p>
  </header>

  {#await data}
    <div class="loading-container">
      <div class="loading" />
    </div>
  {:then allData}
    <Table
      {allData}
      {isMobile}
      bind:selectedCountries
    />

    <Chart
      {allData}
      {selectedCountries}
      {isMobile}
    />

    <footer class="interactive__source">
      <a href="https://chinapower.csis.org" class="source-holder"
        ><img
          src="./images/cpp-logo-red.svg"
          target="_blank"
          alt="ChinaPower Project"
          title="ChinaPower Project"
          width="300"
          height="31"
        /></a
      >
      <div class="source-details">
        <p>
          Source:
          <a
            href="https://unctadstat.unctad.org/wds/ReportFolders/reportFolders.aspx?sCS_ChosenLang=en"
            target="_blank"
            rel="noopener"
            >UNCTAD and MDS Transmodal</a
          >
        </p>
      </div>
    </footer>
  {:catch error}
    <p style="color: red">{error.message}</p>
  {/await}
</main>

<style type="text/scss" global>
  @import "./scss/components/_utilities.scss";
  @import "./scss/layout/_base.scss"; 
  @import "./scss/components/_header.scss";
  @import "./scss/components/_source.scss";
  @import "./scss/components/_loading.scss";
  @import "../scss/components/_tooltips.scss";
</style>
